export const NOT_FOUND_ACTIVE_SUBSCRIBE_MAPP_LIST_STATUS_CODE = 404
export const NOT_FOUND_ACTIVE_SUBSCRIBE_MAPP_LIST_CODE = 'NOT_FOUND_ACTIVE_SUBSCRIBE_MAPP_LIST'
export const NOT_FOUND_ACTIVE_SUBSCRIBE_MAPP_LIST_MESSAGE = 'NOT_FOUND_ACTIVE_SUBSCRIBE_MAPP_LIST'
